import { shootToast } from "codekit";

import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { signOut, getisLoggedIn, getDataUser } from "../../libs/redux/slices/authSlice/authSlice";
import {
  useLogoutMutation,
  useGetTurnsTodayByUserQuery,
  useSetUserAusentMutation,
} from "../../libs/redux/slices/authSlice/authApiSlice";
import { reset } from "../../libs/redux/slices/MenuSlice/menuSlice";
import { resetConsult } from "../../libs/redux/slices/consultSlice/consultSlice";
import { resetCustomFilters } from "../../libs/redux/slices/trackingSlice/trackingSlice";
import { useGetMipuestoMiTurnoQuery, useProrrogarMipuestoMiTurnoMutation } from "../../libs/redux/slices/Mipuesto/mipuestoApiSlice";
import Turnsxxx from "./Modalsxx/Turnsxxx";

const ACTIVITY_KEY = "lastActivityTime";

/**
 * Registra el instante actual como ultima actividad del usuario.
 * @returns {void}
 */
const touchActivity = () => {
  localStorage.setItem(ACTIVITY_KEY, new Date().toISOString());
};

/**
 * Calcula los segundos transcurridos desde la ultima actividad registrada.
 * Si no hay marca valida (primer login del dia, storage recien limpiado) no hay
 * inactividad que medir: se siembra ahora y se cuenta desde cero. Antes se
 * comparaba contra la marca de la sesion anterior y el primer tick del
 * intervalo deslogueaba de una (cazado 2026-08-26).
 * @returns {number} Segundos de inactividad.
 */
const getInactiveSeconds = () => {
  const lastActivityTime = Date.parse(localStorage.getItem(ACTIVITY_KEY));

  if (Number.isNaN(lastActivityTime)) {
    touchActivity();
    return 0;
  }

  return (Date.now() - lastActivityTime) / 1000;
};

const Sessionx = () => {
  const [isAlertShown, setIsAlertShown] = useState(false);
  const [logout] = useLogoutMutation();
  const dispatch = useDispatch();

  const fiftyMinutesAsSeconds = 3000;
  const oneHourAsSeconds = 3600;
  const mintueToContinue = 15;

  const isLoggedIn = useSelector(getisLoggedIn);

  const userData = useSelector(getDataUser) || {};
  const { USRIDXXX } = userData;

  const { data: turnsByUser } = useGetTurnsTodayByUserQuery(
    { USRIDXXX },
    { skip: !isLoggedIn || !USRIDXXX }
  );

  const [setUserAusent, { isLoading: isLoadingTerminate }] = useSetUserAusentMutation();
  //Turnos de los grupos de Ejecutivos (Diego 2026-10-02): el fin de turno no cierra la sesión ni marca ausente. Cinco
  //minutos antes se pregunta si necesita 15 minutos más o entrega el turno. Solo se sigue consultando cada minuto
  //cuando el usuario trabaja por turnos (la primera respuesta no es nula).
  const [trabajaPorTurnos, setTrabajaPorTurnos] = useState(false);
  const { data: miTurno, refetch: refetchMiTurno } = useGetMipuestoMiTurnoQuery(undefined, { skip: !isLoggedIn || !USRIDXXX, pollingInterval: trabajaPorTurnos ? 60000 : 0 });
  const turno = miTurno?.data ?? null;
  const [prorrogarTurno, { isLoading: isProrrogando }] = useProrrogarMipuestoMiTurnoMutation();
  //Hora de fin del turno que el usuario ya decidió entregar: no se le vuelve a preguntar por ese fin
  const [turnoEntregado, setTurnoEntregado] = useState("");
  const isTurnoPorTerminar = Boolean(turno?.EN_TURNO) && Number(turno?.FALTAN ?? 999) <= 5 && turnoEntregado !== turno?.HASTA;
  useEffect(() => {
    setTrabajaPorTurnos(Boolean(turno));
  }, [turno]);
  const handleProrrogarTurno = async () => {
    await prorrogarTurno().unwrap()
      .then(() => refetchMiTurno())
      .catch((e) => shootToast({ variant: "error", text: e?.data?.errors?.message ?? "No se pudo prorrogar el turno.", duration: 5000 }));
  };
  const [isTurnModalOpen, setIsTurnModalOpen] = useState(false);
  const turnTimeoutRef = useRef(null);
  const TZ_OFFSET = "-05:00";
  const CONTINUE_INTERVAL_MS = mintueToContinue * 60 * 1000;

  const clearTurnTimeout = () => {
    if (turnTimeoutRef.current) {
      clearTimeout(turnTimeoutRef.current);
      turnTimeoutRef.current = null;
    }
  };

  const scheduleTurnCheck = (ms) => {
    clearTurnTimeout();
    turnTimeoutRef.current = setTimeout(() => {
      evaluateTurn();
    }, ms);
  };

  const addDays = (dateObj, days) => {
    const d = new Date(dateObj);
    d.setDate(d.getDate() + days);
    return d;
  };

  const toDateAt = (dateStr, timeStr) => new Date(`${dateStr}T${timeStr}${TZ_OFFSET}`);

  const turnComputed = useMemo(() => {
    const dayData = turnsByUser?.data;
    const dateStr = dayData?.DATEXXXX;
    const turns = dayData?.TURNSXXX ?? [];

    if (!dateStr || !Array.isArray(turns) || turns.length === 0) {
      return { ranges: [], lastEnd: null };
    }

    const ranges = turns
      .flatMap((t) =>
        (t.RANGESXX ?? []).map((r) => {
          const start = toDateAt(dateStr, r.STARTXXX);
          let end = toDateAt(dateStr, r.ENDXXXXX);
          if (end <= start) end = addDays(end, 1);

          return { start, end };
        })
      )
      .sort((a, b) => a.start - b.start);

    const lastEnd = ranges.length ? ranges[ranges.length - 1].end : null;
    return { ranges, lastEnd };
  }, [turnsByUser]);

  const onLogoutHard = async () => {
    await logout();
    dispatch(signOut());
    dispatch(reset());
    dispatch(resetConsult());
    dispatch(resetCustomFilters());
    localStorage.clear();
  };

  const evaluateTurn = () => {
    const { ranges, lastEnd } = turnComputed;

    if (!isLoggedIn || !USRIDXXX) return;

    if (!lastEnd || !ranges.length) {
      setIsTurnModalOpen(false);
      clearTurnTimeout();
      return;
    }

    const now = new Date();
    const current = ranges.find((r) => now >= r.start && now < r.end);
    if (current) {
      setIsTurnModalOpen(false);
      const msToEnd = current.end.getTime() - now.getTime();
      scheduleTurnCheck(Math.max(msToEnd, 1000));
      return;
    }
    if (now >= lastEnd) {
      setIsTurnModalOpen(true);
      clearTurnTimeout();
      return;
    }
    const nextPoint = ranges
      .flatMap((r) => [r.start, r.end])
      .filter((d) => d > now)
      .sort((a, b) => a - b)[0];

    if (nextPoint) {
      scheduleTurnCheck(Math.max(nextPoint.getTime() - now.getTime(), 1000));
    }
  };

  const handleTurnContinue = () => {
    setIsTurnModalOpen(false);
    scheduleTurnCheck(CONTINUE_INTERVAL_MS);
  };

  const handleTurnTerminate = async () => {
    try {
      await setUserAusent({ USRIDXXX, TERMINATE: true }).unwrap();
    } catch (e) {
      shootToast({
        variant: "error",
        text: "Ocurrió un error al cerrar el turno. Intente nuevamente.",
        duration: 5000,
      });
      return;
    }
    await onLogoutHard();
  };

  useEffect(() => {
    clearTurnTimeout();

    if (isLoggedIn && USRIDXXX) {
      evaluateTurn();
    } else {
      setIsTurnModalOpen(false);
    }

    return () => clearTurnTimeout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, USRIDXXX, turnComputed.lastEnd?.getTime()]);

  useEffect(() => {
    const checkInactivity = () => {
      const inactiveTimeAsSeconds = getInactiveSeconds();

      if (
        inactiveTimeAsSeconds > fiftyMinutesAsSeconds &&
        inactiveTimeAsSeconds <= oneHourAsSeconds &&
        !isAlertShown
      ) {
        setIsAlertShown(true);
        shootToast({
          text: "Tu sesión está a punto de expirar debido a la inactividad. Por favor, realiza alguna acción para mantenerla activa.",
          variant: "info",
          autoHide: true,
          duration: 10000,
        });
      } else if (inactiveTimeAsSeconds >= oneHourAsSeconds) {
        onLogoutHard();
      }
    };

    if (isLoggedIn) {
      const interval = setInterval(checkInactivity, 5000);
      return () => clearInterval(interval);
    }
  }, [isLoggedIn, isAlertShown]);

  useEffect(() => {
    if (isLoggedIn) {
      touchActivity();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const handleActivity = () => {
      if (isLoggedIn) {
        touchActivity();
      }
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("click", handleActivity);
    window.addEventListener("keydown", handleActivity);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("keydown", handleActivity);
    };
  }, [isLoggedIn]);

  return (
    <>
      <Turnsxxx
        isOpen={isTurnoPorTerminar}
        onContinue={handleProrrogarTurno}
        onTerminate={() => setTurnoEntregado(turno?.HASTA ?? "")}
        isLoading={isProrrogando}
        textoContinuar="Continuar 15 minutos"
        textoTerminar="Entregar el turno"
        texto={`Tu turno termina a las ${String(turno?.HASTA ?? "").slice(11, 16)}. Si necesitas más tiempo para cerrar lo que tienes, «Continuar 15 minutos» te deja en turno ese tiempo. Con «Entregar el turno», a esa hora tus operaciones de clientes por turnos pasan a quien entra y dejas de recibir operaciones nuevas. Tu sesión sigue abierta.`}
      />
      <Turnsxxx
        isOpen={isTurnModalOpen}
        onContinue={handleTurnContinue}
        onTerminate={handleTurnTerminate}
        isLoading={isLoadingTerminate}
        continueMinutesText="15 minutos"
      />
    </>
  );
};

export default Sessionx;
